<template>
  <div>
    <div class="mg-y-10 tx-18" style="color: #21242e">Миний сонгогдсон зөвлөлүүд</div>
    <div v-if="list.length == 0">
      <div class="bg-white rounded-20 mg-t-50 text-center pd-10">
        <div class="" style="margin-top: -50px">
          <img :src="`${myResBaseUrl}v4-assets/img2.png`" />
        </div>
        <div class="mg-t-10 text-muted">Сайн байна уу</div>
        <h6>
          Танд одоогоор сонгогдсон зөвлөл алга байна. Хэрэв та хүсэлтээ илгээсэн бол БШУ яамнаас сонгон шалгаруулалт хийгдэж дууссаны дараа таны сонгогдсон зөвлөл энд байрших болно. Танд амжилт хүсье.
        </h6>
      </div>
    </div>

    <div v-else class="card" v-for="(l, i) in list" :key="i">
      <div class="card-header">{{ l.zarTask.type.name }}</div>
      <div class="card-body pd-0-f">
        <ul class="mg-b-0">
          <li class="list-group-item d-flex align-items-center bd-0 bd-b">
            <div class="">
              <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">Зөвлөлийн нэр</h6>
              <span class="d-block tx-11 text-muted">{{ l.projectTask.task }}</span>
            </div>
          </li>
          <li class="list-group-item d-flex align-items-center bd-0 bd-b">
            <div class="">
              <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">Зөвлөлийн бүрэлдэхүүн</h6>
              <span class="d-block tx-11 text-muted">{{ l.zarTask.task }}</span>
            </div>
          </li>
          <!-- <li class="list-group-item d-flex align-items-center bd-0 bd-b">
            <div class="">
              <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">Үнэлгээ өгөх хугацаа</h6>
              <span class="d-block tx-11 text-muted"
                >{{ l.zarTask.d3 | moment("YYYY.MM.DD") }} -
                {{ l.zarTask.d4 | moment("YYYY.MM.DD") }}</span
              >
            </div>
          </li> -->
        </ul>
      </div>
      <div class="card-footer">
        <!-- <button @click="setMark(l.projectTask.id)" class="mg-l-auto btn btn-info btn-xs">
          үнэлгээ өгөх
        </button> -->
      </div>
    </div>

    <b-modal
      v-model="markObj.modal"
      body-class="test-modal-body bg-light ht-100v"
      dialog-class="test-modal-dialog"
      centered
      scrollable
      title="Үнэлгээ өгөх"
    >
      <div class="ht-100v">
        <div class="d-flex">
          <div class="wd-50p pd-20">
            <task-info
              class="wd-100p bg-white rounded-20 bd pd-20"
              :fields="markObj.fields"
              :obj="{ data: { task: markObj.task } }"
              :loaded="markObj.fetched"
              :boxId="0"
              :parentTask="null"
              @on-attach="showFile"
            />
          </div>
          <div class="wd-50p pd-20" v-if="markObj.fetched">
            <div class="wd-100p bg-white rounded-20 bd pd-20">
              <table class="table table-bordered table-striped wd-100p">
                <thead class="font-weight-bold">
                  <th>Шалгуур үзүүлэлтүүд</th>
                  <th class="wd-50">Таны үнэлгээ</th>
                  <th class="wd-50">Боломжит хамгийн их оноо</th>
                </thead>
                <tbody>
                  
                  <template v-for="(p, i) in pointsDta.points">
                    <tr>
                      <td>{{ p.shalguurName }}</td>
                      <td style="width: 50px" class="wd-50">
                        <InputNumber :min="0" :max="p.maxPoint" v-model="p.point" />
                      </td>
                      <td class="wd-50">{{ p.maxPoint }}</td>
                    </tr>
                    <tr>
                      <td colspan="3">
                        <textarea v-model="p.desc" class="form-control" placeholder="Тайлбар бичнэ үү"></textarea>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>

              <div>
                Үнэлгээ өгсөн тайлбар буюу дүгнэлт энд бичнэ үү
                <textarea class="form-control" rows="6" v-model="pointsDta.execution"></textarea>
              </div>
            </div>
            <!-- {{ markObj.task.b.length }}
                    <div v-for="(b, i) in markObj.task.b" :key="i">{{ b.otCompName }}</div> -->
            <!-- <h1>энд box зурах гээд bug тай үлдээсэн :D</h1> -->
            <div v-for="(b, i) in markObj.task.b" :key="i">
              <loader
                :ref="`ldr_box_${b.id}`"
                :box="b"
                :prms="{ boxChooser: false }"
                :detailSettingProp="{
                  boxSetting: {
                    listSetting: { height: 0 },
                    hideToolbar: true,
                    hideEmptyTemplate: true,
                    autoHeight: true,
                    hideFooter: true,
                  },
                }"
                @on-attach="showFile($event)"
                @on-detail="showDetail"
                @load-box="loadBoxData"
              />
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <!-- <p class="float-left">энд тайлбар бичнэ</p> -->
          <b-button variant="primary" size="sm" class="float-right" @click="postPoints()">
            Үр дүнг хадгалах
          </b-button>
        </div>
      </template>
    </b-modal>

    <file-dialog
      :show="fileDialog.show"
      :id="fileDialog.id"
      @on-hide="fileDialog.show = false"
    />
  </div>
</template>
<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { request } from "@/api/all";
import { getDetailFields } from "@/api/taskCore";

import loader from "@/components/box/loader/loader.vue";

import "element-ui/lib/theme-chalk/index.css";
import { InputNumber, MessageBox } from "element-ui";

export default {
  components: {
    loader,
    InputNumber,
    MessageBox,
    taskInfo: () => ({
      component: import("@/components/task/detail/ot/components/info.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fileDialog: {
        id: null,
        show: false,
      },
      markObj: {
        fields: [],
        task: {
          b: [],
        },
        id: null,
        modal: false,
        fetched: false,
      },
      pointsDta: {
        points: [],
        projectTaskId: null,
        execution: null,
      },
      myResBaseUrl: "https://res.gosmart.mn/",
    };
  },
  created() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }
  },
  mounted() {
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    setMark(id) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      getDetailFields({ params: { objectTypeId: 561 } }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.markObj.fields = res.data.fields;
          this.markObj.fetched = true;
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { method: "GET", url: "task/TaskInheritedDetail" },
            params: { id: id },
            store: this.$store,
          }).then((rest) => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (rest != false) {
              this.markObj.task = rest.data.task;
              //this.markObj.task.b.unshift({id: 0, nm: 'Ерөнхий мэдээлэл'});

              this.markObj.id = id;
              this.markObj.modal = true;

              this.getMyPoints(id);
            }
          });
        }
      });
    },
    getMyPoints(id) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "ProjectEdu/GetMyPointsByProjectTaskId" },
        params: { projectTaskId: id },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.pointsDta = res.data;
          //console.log('res', res);
        }
      });
    },
    showFile(e) {
      // console.log('e', e);
      this.markObj.modal= false;
      this.fileDialog.id = e;
      this.fileDialog.show = true;
    },
    showDetail() {},
    loadBoxData() {},
    postPoints() {
      MessageBox.confirm("Та үнэлгээг хадгалахдаа итгэлтэй байна уу ?", "Санам", {
        confirmButtonText: "Тийм",
        cancelButtonText: "Үгүй",
        type: "warning",
      })
        .then(() => {
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { method: "POST", url: "ProjectEdu/SetMyPointsByProjectTaskId" },
            data: this.pointsDta,
            store: this.$store,
          }).then((res) => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              //console.log("res", res);
              this.markObj.modal = false;
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style>
.test-modal-body {
  /* width: calc(100% - 2rem);
    min-height: 100%;
    height: auto;
    margin: 1rem; */
  margin: 0;
  padding: 0;
}

.test-modal-dialog {
  max-width: 100%;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  display: flex;
  position: fixed;
  z-index: 100000;
}
</style>
